import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import Logo from "../components/Logo";
import api from "../lib/api";

export default function PaymentResult() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { pathname } = useLocation();
  const cancelled = pathname.includes("cancel");
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(cancelled ? "cancelled" : "checking");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (cancelled || !sessionId) return;
    if (tries > 8) { setStatus("timeout"); return; }
    const t = setTimeout(() => {
      api.get(`/payments/status/${sessionId}`).then((r) => {
        if (r.data.payment_status === "paid") setStatus("paid");
        else if (["failed", "expired"].includes(r.data.payment_status)) setStatus("failed");
        else setTries((n) => n + 1);
      }).catch(() => setTries((n) => n + 1));
    }, tries === 0 ? 500 : 2000);
    return () => clearTimeout(t);
  }, [sessionId, tries, cancelled]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-cloud px-6 text-center">
      <Logo />
      <div className="mt-12 w-full max-w-md rounded-3xl border border-slate-200 bg-white p-10">
        {status === "checking" && (<><Loader2 className="mx-auto h-14 w-14 animate-spin text-brandblue" /><h1 className="mt-6 font-display text-2xl font-bold text-navy">Confirming your payment…</h1></>)}
        {status === "paid" && (<><CheckCircle2 className="mx-auto h-14 w-14 text-successBrand" /><h1 className="mt-6 font-display text-2xl font-bold text-navy">Payment Confirmed!</h1><p className="mt-2 text-slateBrand">Your registration is complete. A confirmation is waiting in your dashboard.</p></>)}
        {(status === "failed" || status === "timeout") && (<><XCircle className="mx-auto h-14 w-14 text-alertBrand" /><h1 className="mt-6 font-display text-2xl font-bold text-navy">Payment not confirmed</h1><p className="mt-2 text-slateBrand">We couldn't confirm your payment. Please check your dashboard or try again.</p></>)}
        {status === "cancelled" && (<><XCircle className="mx-auto h-14 w-14 text-slate-400" /><h1 className="mt-6 font-display text-2xl font-bold text-navy">Checkout cancelled</h1><p className="mt-2 text-slateBrand">No charge was made. You can register again anytime.</p></>)}
        <Button data-testid="payment-result-dashboard-btn" onClick={() => navigate("/dashboard")} className="mt-8 h-12 w-full bg-brandblue font-display font-semibold hover:bg-blue-700">Go to Dashboard</Button>
      </div>
    </div>
  );
}
